/* ══════════════════════════════════════════════════════════════════════════
 * visit.js — THE VISIT A RESTAURANT GAVE YOU AT THE DOOR (171, 9 Oct 2026)
 *
 * Restaurant Admin Lite seats a walk-in, the guest says Eleat sent them, and
 * the restaurant's one message carries a link: ?join=1&visit=<token> (not on
 * Eleat yet) — join, and the visit is theirs. The token is kept on the phone
 * until the person is signed in, then POST /visits/claim makes it a confirmed
 * visit and they land on that restaurant's reviews, where they can now write
 * one. A link that is no longer valid is forgotten quietly.
 * ══════════════════════════════════════════════════════════════════════════ */
import { call, getToken, SIGNED_IN_EVENT } from './api.js';
import { go } from './nav.js';

const KEY = 'eleat.visitClaim';

export function claimPendingVisit() {
  let tok = null;
  try {
    const t = new URLSearchParams(window.location.search).get('visit');
    if (t) window.localStorage.setItem(KEY, t);
    tok = window.localStorage.getItem(KEY);
  } catch (e) { return; }
  if (!tok || !getToken()) return;
  call('/visits/claim', { method: 'POST', body: { token: tok }, auth: true })
    .then((r) => {
      try { window.localStorage.removeItem(KEY); } catch (e) { /* gone anyway */ }
      if (r && r.restaurant_id) {
        go('?venue=' + encodeURIComponent(r.restaurant_id) + '&tab=reviews', { replace: true });
      }
    })
    .catch((e) => {
      /* a real answer (expired, someone else's, not valid) ends it; no
         connection keeps it for the next open */
      if (e && e.status) { try { window.localStorage.removeItem(KEY); } catch (x) { /* none */ } }
    });
}

/* signed in on this page without a reload (SignIn, Reset) — a visit link
   opened while signed out is claimed the moment there is somebody to give it to */
if (typeof window !== 'undefined') window.addEventListener(SIGNED_IN_EVENT, () => claimPendingVisit());
